import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { tokens } from '../../theme';

// Second-level switch inside a section (pill style, so it never looks like the section tabs).
// items: [{ key, label }]
const SubTabs = ({ items, value, onChange, sx }) => (
  <Box role="tablist" sx={{ display: 'inline-flex', flexWrap: 'wrap', gap: 0.5, p: 0.5, bgcolor: tokens.paper, border: `1px solid ${tokens.border}`, borderRadius: '14px', ...sx }}>
    {items.map((it) => {
      const active = it.key === value;
      return (
        <ButtonBase key={it.key} role="tab" aria-selected={active} onClick={() => onChange(it.key)}
          sx={{
            px: 2, py: 1, borderRadius: '11px', fontSize: '0.9375rem', fontWeight: 600, whiteSpace: 'nowrap',
            color: active ? '#fff' : tokens.inkSoft, bgcolor: active ? tokens.primary : 'transparent',
            transition: 'background-color .2s, color .2s',
            '&:hover': { bgcolor: active ? tokens.primaryDark : tokens.primaryTint, color: active ? '#fff' : tokens.ink },
          }}>
          {it.label}
        </ButtonBase>
      );
    })}
  </Box>
);

export default SubTabs;
